import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import ActionTable from "../../components/table/ActionTable";
import api from "../../services/api";
import AppContext from "../../container/context";
import { mergeParams } from "../../helpers/helpers";
import Form from "../../components/form";
import { formatDateTime } from "../../helpers/helpers";

export default function Lista({ history, location }) {
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState(
    mergeParams({ nome: "", exibirInativos: false }, location)
  );
  const [lista, setLista] = useState([]);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregarGrupos();
  }, []);

  const carregarGrupos = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);
    setCarregando(true);

    api
      .get("gruposPreco/listar", filtrosEnviar)
      .then((res) => {

        res.forEach(r => {
            r.validade = r.validade ? formatDateTime(r.validade, "D/M/Y h:m") : '(indefinida)';
            r.valor = (r.valorCentavos / 100).toFixed(2);
        });

        setLista(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar grupos");
        setCarregando(false);
      });
  };

  const filtros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 8,
        value: dados.nome,
      },
      exibirVencidos: {
        label: "Exibir vencidos",
        type: "check",
        space: 4,
        value: dados.exibirVencidos,
      },
    },

    submit: {
      label: "Buscar",
      action: carregarGrupos,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirGrupo = (registro) => {
    history.push(`/app/grupo-preco/${registro.id}`);
  };

  const tRegistros = {
    title: "Grupos",
    onLineClick: abrirGrupo,
    newItemAction: () => history.push("/app/grupo-preco/0"),
    columns: [
      {
        name: "nome",
        label: "Nome",
      },
      {
        name: "valor",
        label: "Valor (R$)",
      },
      {
        name: "validade",
        label: "Validade"
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={filtros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
